import { FormData, SetFormData } from './FormData.tsx';
import ImageUploader from '../../../components/ImageUploader.tsx';
import { useEffect, useState } from 'react';

interface listingForm {
  formData: FormData;
  setFormData: SetFormData;
  setNextDisabled: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function WorkspaceImages({ formData, setFormData, setNextDisabled }: listingForm) {
    const [showTooltip, setShowTooltip] = useState(true);

    useEffect(() => {
        if (formData.images.length > 4) {
            setShowTooltip(false);
            setNextDisabled(false);
        } else {
            setShowTooltip(true);
            setNextDisabled(true);
        }
    }, [formData.images]); // Only depend on formData.images

    return (
        <div className="space-y-4">
            <h2 className="text-3xl font-bold mb-4">Showcase your workspace!</h2>
            <hr className="border-t border-gray-500 my-4 w-full shadow-gray-400" />
            
            <ImageUploader
                existingImages={formData.images} // Pass existing images to the uploader
                onImagesChange={(newImages) => {
                    setFormData({ ...formData, images: newImages });
                }}
            />
            
            {showTooltip && (
                <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-4">
                    <div className="flex">
                        <div className="flex-shrink-0">
                            <svg className="h-5 w-5 text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2h-1V9z" clipRule="evenodd" />
                            </svg>
                        </div>
                        <div className="ml-3">
                            <p className="text-sm text-blue-700">
                                <strong>Tip:</strong> You need to upload at least 5 images to continue. Adding more images (up to the maximum) will significantly increase your chances of leasing the workspace.
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}